import { useSetLock } from "@/shared/atoms/useLock";
import { forwardRef, memo, useEffect, useRef, useState } from "react";
import PinField from "react-pin-field";
import Icon from "../Icon/Icon";

const pinInputClassName =
  "mb-[5px] mr-[5px] h-[96px] w-[96px] border-none bg-[#f3f3f3] text-center text-[72px] focus:border focus:border-[#573d8b] focus:outline-none";

const Styled = forwardRef<
  HTMLInputElement[],
  React.ComponentProps<typeof PinField>
>((props, ref) => (
  <div className="my-8 flex flex-wrap justify-center">
    <PinField ref={ref} className={pinInputClassName} {...props} />
  </div>
));
Styled.displayName = "StyledPinField";

const Button = ({ className = "", ...props }) => (
  <button
    className={`mr-[5px] h-[96px] w-[96px] border-none bg-[#f3f3f3] text-center text-[72px] focus:border focus:border-[#573d8b] focus:outline-none ${className}`.trim()}
    {...props}
  />
);

const PinKeyboard = ({ onInput }) => {
  const handleButtonClick = (value) => {
    onInput(value);
  };

  return (
    <div className="flex flex-col items-center">
      <div className="my-2 flex gap-4">
        {[1, 2, 3].map((num) => (
          <Button
            type="button"
            key={num}
            onClick={() => handleButtonClick(num)}
          >
            {num}
          </Button>
        ))}
      </div>
      <div className="my-2 flex gap-4">
        {[4, 5, 6].map((num) => (
          <Button
            type="button"
            key={num}
            onClick={() => handleButtonClick(num)}
          >
            {num}
          </Button>
        ))}
      </div>
      <div className="my-2 flex gap-4">
        {[7, 8, 9].map((num) => (
          <Button
            type="button"
            key={num}
            onClick={() => handleButtonClick(num)}
          >
            {num}
          </Button>
        ))}
      </div>
      <div className="my-2 flex gap-4">
        <Button
          type="button"
          onClick={() => handleButtonClick("delete")}
          className="delete-btn flex justify-center items-center"
        >
          <Icon className="h-20 w-20" variants="deleteLeft" />
        </Button>
        <Button type="button" onClick={() => handleButtonClick(0)}>
          0
        </Button>
        <Button
          type="button"
          onClick={() => handleButtonClick("submit")}
          className="submit-btn flex justify-center items-center"
        >
          <Icon className="h-20 w-20" variants="bracket" />
        </Button>
      </div>
    </div>
  );
};

const Pin = ({ onSubmit }: any) => {
  const [pin, setPin] = useState([]);
  const setLock = useSetLock();
  const ref = useRef<HTMLInputElement[]>([]);
  const addToPin = (value: string | number) => {
    if (value === "submit") {
      if (pin.length >= 4 && pin.length <= 8) {
        return onSubmit(pin);
      }
      return;
    }

    if (value === "delete") {
      return setPin((v) => {
        let data = [...v];
        data.pop();
        return data;
      });
    }
    setPin((v) => (v.length < 8 ? [...v, String(value)] : v));
  };

  useEffect(() => {
    ref.current?.forEach((input, index) => {
      if (input) {
        input.value = pin[index] ?? "";
      }
    });
  }, [pin]);

  return (
    <div className="text-center p-[2.5rem] bg-[white] w-full sm:w-[inherit] max-w-[95%] sm:max-w-[inherit]">
      {/* <Brand width="100%" maxWidth="30rem" /> */}
      <div className="my-[2rem]" style={{ pointerEvents: "none" }}>
        <Styled length={8} ref={ref} validate={/^[0-9]+$/} />
      </div>
      <PinKeyboard
        onInput={(v) => {
          addToPin(v);
        }}
      />
    </div>
  );
};

export default memo(Pin);
